<template>
  <v-fade-transition mode="out-in">
    <router-view/>
  </v-fade-transition>
</template>

<script>
import VFadeTransition from '@/components/transitions/VFadeTransition'

export default {
  components: { VFadeTransition }
}
</script>